import React from 'react';
import { LandingTopWidget } from '../../organisms/landing';
import { SettingsWrapper } from '../../organisms/settings/SettingsWrapper';
import { SettingsAccessControl } from '../../organisms/settings/SettingsAccessControl';
import { InvoiceChargeMain } from '../../organisms/settings/invoiceCharge/InvoiceChargeMain';

/**
 * presentations/components/pages/settings/InvoiceChargePage.tsx
 */
const InvoiceChargePage: React.FC = () => (
  <SettingsAccessControl allowedRoles='systemAdmin'>
    <div className='h-full flex flex-col bg-white'>
      <LandingTopWidget title='Settings' hideSearchBar hideUploadButton />

      <SettingsWrapper>
        <InvoiceChargeMain />
      </SettingsWrapper>
    </div>
  </SettingsAccessControl>
);

export default InvoiceChargePage;
